var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 76,
    viewBox: "0 0 106 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 61.4999V14.8999H0.399994V61.4999C0.399994 63.0999 1.69999 64.3999 3.29999 64.3999H84.1C85.7 64.3999 87 63.0999 87 61.4999Z",
    fill: "#82AA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87 3.0001C87 1.4001 85.7 0.100098 84.1 0.100098H3.19999C1.59999 0.100098 0.299988 1.4001 0.299988 3.0001V12.4001H87V3.0001Z",
    fill: "#82AA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 7.7001C8.3 7.7001 9.1 6.9001 9.1 5.9001C9.1 4.9001 8.2 4.1001 7.3 4.1001C6.4 4.1001 5.5 5.0001 5.5 5.9001C5.5 6.8001 6.3 7.7001 7.3 7.7001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 7.7001C13.9 7.7001 14.7 6.9001 14.7 5.9001C14.7 4.9001 13.9 4.1001 12.9 4.1001C11.9 4.1001 11.1 5.0001 11.1 5.9001C11.1 6.8001 11.9 7.7001 12.9 7.7001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 7.7001C19.6 7.7001 20.4 6.9001 20.4 5.9001C20.4 4.9001 19.6 4.1001 18.6 4.1001C17.6 4.1001 16.8 5.0001 16.8 5.9001C16.8 6.8001 17.6 7.7001 18.6 7.7001Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9 75.7998C94.4 75.7998 105.4 64.7998 105.4 51.2998C105.4 37.7998 94.4 26.7998 80.9 26.7998C67.4 26.7998 56.4 37.7998 56.4 51.2998C56.4 64.7998 67.4 75.7998 80.9 75.7998Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6 51.3003C75.7 50.3003 73.1 49.8003 71.4 49.8003C68.6 49.8003 63.1 51.2003 63.1 54.0003V59.0003H70.2V56.3003C70.2 53.6003 74.1 52.0003 77.6 51.3003Z",
    fill: "#82AA00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2 51.3003C86.1 50.3003 88.7 49.8003 90.4 49.8003C93.2 49.8003 98.7 51.2003 98.7 54.0003V59.0003H91.6V56.3003C91.6 53.6003 87.7 52.0003 84.2 51.3003Z",
    fill: "#82AA00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4 47.4002C92.4 47.4002 94 45.8002 94 43.8002C94 41.8002 92.4 40.2002 90.4 40.2002C88.4 40.2002 86.8 41.8002 86.8 43.8002C86.9 45.8002 88.5 47.4002 90.4 47.4002Z",
    fill: "#82AA00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9 50.8001C82.9 50.8001 84.5 49.2001 84.5 47.2001C84.5 45.2001 82.9 43.6001 80.9 43.6001C78.9 43.6001 77.3 45.2001 77.3 47.2001C77.3 49.2001 78.9 50.8001 80.9 50.8001Z",
    fill: "#82AA00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9 53.1001C78.1 53.1001 72.6 54.5001 72.6 57.3001V62.3001H89.3V57.3001C89.2 54.5001 83.7 53.1001 80.9 53.1001Z",
    fill: "#82AA00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43.8002C75 41.8002 73.4 40.2002 71.4 40.2002C69.4 40.2002 67.8 41.8002 67.8 43.8002C67.8 45.8002 69.4 47.4002 71.4 47.4002C73.4 47.4002 75 45.8002 75 43.8002Z",
    fill: "#82AA00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8 24.2002H26V28.3002H59.8V24.2002Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4 31.4004H26V35.5004H43.4V31.4004Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24.2002H9.20001V35.5002H20.5V24.2002Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 30.9001L11.7 28.8001L10.5 30.0001L13.7 33.2001L19.2 27.7001L18 26.6001L13.7 30.9001Z",
    fill: "#82AA00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2 43.8999H26V47.9999H52.2V43.8999Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4 51.1001H26V55.2001H43.4V51.1001Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 44H9.20001V55.3H20.5V44Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 50.5998L11.7 48.5998L10.5 49.6998L13.7 52.8998L19.2 47.3998L18 46.2998L13.7 50.5998Z",
    fill: "#82AA00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.bb8f45c2ae7707c608740c83fae1d72d.svg";
export { ForwardRef as ReactComponent };